<div class="main-container-position p-4 lg:p-8">
  <div class="profile-banner w-full lg:w-4/5 mx-auto gap-6">
    <h1 class="text-2xl sm:text-3xl md:text-3xl mb-8">Dein Profil</h1>

    <form
      [formGroup]="userForm"
      (ngSubmit)="updateUser()"
      class="user-form mb-6"
      >
      @if (!isCompanyUser() || isAdminUser()) {
        <mat-card class="md:p-6">
          <mat-card-header>
            <mat-card-title>
              <span class="text-lg font-semibold">Persönliche Daten</span>
            </mat-card-title>
          </mat-card-header>
          <mat-card-content>
            @if(loadingUserProfile.loading) {
              <app-loading-indication
                displayText="Lade deine Daten..."
                size="large"
              ></app-loading-indication>
            } @else {
              <div class="profile-picture-section mb-6 flex flex-col items-center">
                <div
                  class="profile-picture-container cursor-pointer relative mb-2"
                  (click)="!isUploading && triggerFileInput()"
                  tabindex="0"
                  role="button"
                  (keyup.enter)="!isUploading && triggerFileInput()"
                  [class.has-image]="userForm.get('profilePictureUrl')?.value"
                  [class.uploading]="isUploading"
                  >
                  @if(userForm.get('profilePictureUrl')?.value) {
                    <img
                      [src]="userForm.get('profilePictureUrl')?.value"
                      alt="Profile picture"
                      class="rounded-full w-32 h-32 object-cover"
                      />
                  } @else {
                    <div
                      class="placeholder-circle rounded-full w-32 h-32 bg-gray-200 flex items-center justify-center"
                      >
                      <span class="material-symbols-outlined text-4xl text-gray-400"
                        >person</span
                        >
                      </div>
                      } @if(!isUploading) {
                      <div
                        class="upload-overlay absolute inset-0 rounded-full flex items-center justify-center bg-black bg-opacity-50 opacity-0 hover:opacity-100 transition-opacity"
                        >
                        <span class="material-symbols-outlined text-white"
                          >photo_camera</span
                          >
                        </div>
                      } @else {
                        <div
                          class="upload-overlay absolute inset-0 rounded-full flex items-center justify-center bg-black bg-opacity-50 opacity-100"
                          >
                          <span class="material-symbols-outlined text-white animate-spin"
                            >sync</span
                            >
                          </div>
                        }
                      </div>
                      <input
                        #fileInput
                        type="file"
                        accept="image/*"
                        (change)="onFileSelected($event)"
                        class="hidden"
                        [disabled]="isUploading"
                        />
                      <p class="text-sm text-gray-600">
                        @if(isUploading) { Bild wird hochgeladen... } @else { Klicke um
                          ein Profilbild hochzuladen }
                        </p>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-4">
                        <div class="w-full">
                          <mat-form-field class="w-full">
                            <mat-label>Vorname</mat-label>
                            <input
                              matInput
                              formControlName="firstName"
                              placeholder="Vorname eingeben"
                              />
                            @if (userForm.get('firstName')?.errors?.['required']) {
                              <mat-error
                                >
                                Vorname ist erforderlich
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="w-full">
                          <mat-form-field class="w-full">
                            <mat-label>Nachname</mat-label>
                            <input
                              matInput
                              formControlName="lastName"
                              placeholder="Nachname eingeben"
                              />
                            @if (userForm.get('lastName')?.errors?.['required']) {
                              <mat-error
                                >
                                Nachname ist erforderlich
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="flex flex-col md:flex-row md:gap-4">
                        <div class="w-full">
                          <mat-form-field class="w-full">
                            <mat-label>Geschlecht</mat-label>
                            <mat-select formControlName="gender">
                              <mat-option value="male">Männlich</mat-option>
                              <mat-option value="female">Weiblich</mat-option>
                              <mat-option value="diverse">Divers</mat-option>
                              <mat-option value="other">Keine Angabe</mat-option>
                            </mat-select>
                            @if (userForm.get('gender')?.errors?.['required']) {
                              <mat-error>
                                Geschlecht ist erforderlich
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                        <div class="w-full">
                          <mat-form-field class="w-full">
                            <mat-label>Geburtsjahr</mat-label>
                            <input
                              matInput
                              formControlName="birthYear"
                              type="number"
                              placeholder="Geburtsjahr eingeben"
                              class="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none"
                              />
                            @if (userForm.get('birthYear')?.errors?.['min'] || userForm.get('birthYear')?.errors?.['max']) {
                              <mat-error
                                >
                                Bitte geben Sie ein gültiges Geburtsjahr ein
                              </mat-error>
                            }
                          </mat-form-field>
                        </div>
                      </div>
                      <div class="form-group">
                        <mat-form-field class="w-1/2">
                          <mat-label>PLZ</mat-label>
                          <input
                            matInput
                            formControlName="zipCode"
                            placeholder="PLZ eingeben"
                            />
                          @if (userForm.get('zipCode')?.errors?.['pattern']) {
                            <mat-error>
                              Bitte geben Sie eine gültige PLZ ein
                            </mat-error>
                          }
                        </mat-form-field>
                      </div>
                      <div class="w-full mb-4">
                        <mat-form-field class="w-full">
                          <mat-label>Kategorien</mat-label>
                          <mat-select formControlName="categories" multiple>
                            @for (category of availableCategories; track category) {
                              <mat-option
                                [value]="category.id"
                                >
                                {{ category.name }}
                              </mat-option>
                            }
                          </mat-select>
                          @if (userForm.get('categories')?.errors?.['required']) {
                            <mat-error
                              >
                              Bitte wählen Sie mindestens eine Kategorie aus
                            </mat-error>
                          }
                        </mat-form-field>
                        <div class="selected-categories flex flex-wrap gap-2 mt-2">
                          @if (userForm.get('categories')?.value?.length) {
                            <mat-chip-set>
                              @for (categoryId of userForm.get('categories')?.value; track categoryId) {
                                <mat-chip
                                  >
                                  {{ getCategoryName(categoryId) }}
                                </mat-chip>
                              }
                            </mat-chip-set>
                          }
                        </div>
                      </div>
                    }
                  </mat-card-content>
                  <mat-card-actions>
                    <button
                      i18n
                      class="button-blue"
                      type="submit"
            [disabled]="
              !userForm.valid ||
              loadingUserProfile.saving ||
              loadingUserProfile.loading
            "
                      >
            @if(loadingUserProfile.saving) {
            <span class="animate-pulse">Lade ...</span>
            } @else { Daten aktualisieren }
          </button>
                    </mat-card-actions>
                  </mat-card>
                }
              </form>

              @if (!isCompanyUser() || isAdminUser()) {
                <mat-card class="md:p-6 mb-6">
                  <mat-card-header class="mb-4">
                    <mat-card-title>
                      <span class="text-lg font-semibold">Gepflegte Person</span>
                    </mat-card-title>
                  </mat-card-header>
                  <mat-card-content class="p-0">
                    @if(loadingManagedUsers) {
                      <app-loading-indication
                        displayText="Lade zu Gepflegte Person..."
                        size="large"
                      ></app-loading-indication>
                    } @else if(managedUsers.length === 0 && !showNewUserForm) {
                      <div class="text-center py-4">
                        <p class="text-gray-600">Keine verwalteten Benutzer vorhanden.</p>
                      </div>
                      } @if(managedUsers.length > 0) {
                      <mat-accordion [multi]="false" class="w-full">
                        @for(user of managedUsers; track user.id; let i = $index) { @if(user)
                          {
                          <mat-expansion-panel
                            [expanded]="activeExpansionPanel === i"
                            (opened)="onPanelOpened(i)"
                            >
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <div class="flex items-center gap-4">
                                  @if(user.profilePicture?.url) {
                                    <img
                                      [src]="user.profilePicture?.url"
                                      alt="Profile picture"
                                      class="w-8 h-8 rounded-full object-cover"
                                      />
                                  } @else {
                                    <div
                                      class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center"
                                      >
                                      <span
                                        class="material-symbols-outlined text-gray-400 text-sm"
                                        >person</span
                                        >
                                      </div>
                                    }
                                    {{ user.firstName }} {{ user.lastName }}
                                  </div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <app-managed-user-management
                                [user]="user"
                                (userChanged)="onManagedUserChanged($event)"
                              ></app-managed-user-management>
                            </mat-expansion-panel>
                            } }
                          </mat-accordion>
                          } @if(showNewUserForm) {
                          <mat-expansion-panel
                            [expanded]="activeExpansionPanel === managedUsers.length"
                            (opened)="onPanelOpened(managedUsers.length)"
                            >
                            <mat-expansion-panel-header>
                              <mat-panel-title>
                                <div class="flex items-center gap-4">
                                  <div
                                    class="w-8 h-8 rounded-full bg-gray-200 flex items-center justify-center"
                                    >
                                    <span class="material-symbols-outlined text-gray-400 text-sm"
                                      >person_add</span
                                      >
                                    </div>
                                    Neuer Benutzer
                                  </div>
                                </mat-panel-title>
                              </mat-expansion-panel-header>
                              <app-managed-user-management
                                [user]="null"
                                (userChanged)="onManagedUserChanged($event)"
                              ></app-managed-user-management>
                            </mat-expansion-panel>
                            } @if(!showNewUserForm) {
                            <div class="mt-4">
                              <button class="button-blue" (click)="addNewManagedUser()">
                                <div class="flex items-center gap-2">
                                  <span class="material-symbols-outlined mr-2">add</span>
                                  Neue Person anlegen
                                </div>
                              </button>
                            </div>
                          }
                        </mat-card-content>
                      </mat-card>
                    }

                    @if(isCompanyUser()) {
                      <form
                        [formGroup]="companyForm"
                        (ngSubmit)="updateCompany()"
                        class="company-form mb-6"
                        >
                        <mat-card class="md:p-6">
                          <mat-card-header>
                            <mat-card-title>
                              <span class="text-lg font-semibold">Firmendaten</span>
                            </mat-card-title>
                          </mat-card-header>
                          <mat-card-content>
                            @if(loadingCompanyProfile.loading) {
                              <app-loading-indication
                                displayText="Lade Firmendaten..."
                                size="large"
                              ></app-loading-indication>
                            } @else {
                              <div class="flex flex-col md:flex-row md:gap-4">
                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>Firmenname</mat-label>
                                    <input
                                      matInput
                                      formControlName="companyName"
                                      placeholder="Firmenname eingeben"
                                      />
                                    @if (companyForm.get('companyName')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        Firmenname ist erforderlich
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>

                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>Ansprechperson</mat-label>
                                    <input
                                      matInput
                                      formControlName="contactPersonName"
                                      placeholder="Ansprechperson eingeben"
                                      />
                                    @if (companyForm.get('contactPersonName')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        Ansprechperson ist erforderlich
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </div>

                              <div class="flex flex-col md:flex-row md:gap-4">
                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>E-Mail</mat-label>
                                    <input
                                      matInput
                                      formControlName="email"
                                      type="email"
                                      placeholder="E-Mail eingeben"
                                      />
                                    @if (companyForm.get('email')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        E-Mail ist erforderlich
                                      </mat-error>
                                    }
                                    @if (companyForm.get('email')?.errors?.['email']) {
                                      <mat-error>
                                        Bitte geben Sie eine gültige E-Mail-Adresse ein
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>

                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>UID</mat-label>
                                    <input
                                      matInput
                                      formControlName="uid"
                                      placeholder="UID eingeben"
                                      />
                                  </mat-form-field>
                                </div>
                              </div>

                              <div class="flex flex-col md:flex-row md:gap-4">
                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>Website</mat-label>
                                    <input
                                      matInput
                                      formControlName="website"
                                      placeholder="Website eingeben"
                                      />
                                    @if (companyForm.get('website')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        Website ist erforderlich
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>

                                <div class="w-full">
                                  <mat-form-field class="w-full">
                                    <mat-label>Telefonnummer</mat-label>
                                    <input
                                      matInput
                                      formControlName="phone"
                                      placeholder="Telefonnummer eingeben"
                                      />
                                  </mat-form-field>
                                </div>
                              </div>

                              <div class="w-full mb-4">
                                <mat-form-field class="w-full">
                                  <mat-label>Kategorien</mat-label>
                                  <mat-select formControlName="categories" multiple>
                                    @for (category of availableCategories; track category) {
                                      <mat-option
                                        [value]="category.id"
                                        >
                                        {{ category.name }}
                                      </mat-option>
                                    }
                                  </mat-select>
                                  @if (categoriesControl?.errors?.['required']) {
                                    <mat-error>
                                      Bitte wählen Sie mindestens eine Kategorie aus
                                    </mat-error>
                                  }
                                </mat-form-field>

                                <div class="selected-categories flex flex-wrap gap-2 mt-2">
                                  @if (categoriesControl?.value?.length) {
                                    <mat-chip-set>
                                      @for (categoryId of categoriesControl?.value; track categoryId) {
                                        <mat-chip>
                                          {{ getCategoryName(categoryId) }}
                                        </mat-chip>
                                      }
                                    </mat-chip-set>
                                  }
                                </div>
                              </div>

                              <div formGroupName="address" class="flex flex-col gap-4 mt-4">
                                <h3>Firmenanschrift</h3>

                                <mat-form-field>
                                  <mat-label>Straße und Hausnummer</mat-label>
                                  <input matInput formControlName="street" />
                                  @if (companyForm.get('address')?.get('street')?.errors?.['required']) {
                                    <mat-error
                                      >
                                      Straße ist erforderlich
                                    </mat-error>
                                  }
                                </mat-form-field>

                                <div class="flex flex-row gap-4">
                                  <mat-form-field class="w-full">
                                    <mat-label>Ort</mat-label>
                                    <input matInput formControlName="city" />
                                    @if (companyForm.get('address')?.get('city')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        Ort ist erforderlich
                                      </mat-error>
                                    }
                                  </mat-form-field>

                                  <mat-form-field class="w-full">
                                    <mat-label>Postleitzahl</mat-label>
                                    <input matInput formControlName="postalCode" />
                                    @if (companyForm.get('address')?.get('postalCode')?.errors?.['required']) {
                                      <mat-error
                                        >
                                        Postleitzahl ist erforderlich
                                      </mat-error>
                                    }
                                  </mat-form-field>
                                </div>
                              </div>
                            }
                          </mat-card-content>
                          <mat-card-actions>
                            <button
                              i18n
                              class="button-blue"
                              type="submit"
            [disabled]="
              !companyForm.valid ||
              loadingCompanyProfile.saving ||
              loadingCompanyProfile.loading
            "
                              >
            @if(loadingCompanyProfile.saving) {
            <span class="animate-pulse">Lade ...</span>
            } @else { Firmendaten aktualisieren }
          </button>
                            </mat-card-actions>
                          </mat-card>
                        </form>
                      }

                      @if (!isCompanyUser() || isAdminUser()) {
                        <div
                          class="cards-profile flex flex-col lg:flex-row justify-between gap-6"
                          >
                          <div class="w-full grid grid-cols-1 gap-6">
                            <mat-card class="bg-white shadow-md rounded-xl md:p-6">
                              <mat-card-header>
                                <mat-card-title>
                                  <span class="text-lg font-semibold" i18n>Rechtliches</span>
                                </mat-card-title>
                              </mat-card-header>
                              <mat-card-content>
                                <div class="flex flex-col gap-4 mt-4">
                                  <a
                                    href="https://sondis.at/datenschutz"
                                    target="_blank"
                                    class="flex items-center hover:text-blue-500"
                                    >
                                    Datenschutzerklärung
                                    <span class="material-symbols-outlined ml-1">open_in_new</span>
                                  </a>
                                  <a
                                    href="https://sondis.at/agb"
                                    target="_blank"
                                    class="flex items-center hover:text-blue-500"
                                    >
                                    Allgemeine Geschäftsbedingungen
                                    <span class="material-symbols-outlined ml-1">open_in_new</span>
                                  </a>
                                </div>
                              </mat-card-content>
                            </mat-card>
                          </div>
                        </div>
                      }
                    </div>
                  </div>
